import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { tableBank } from "../../../../data/mock/table";
import { message } from "antd";
import '../../../../App.css'

export const UseFetchUserSchedule = (shift) => {
  return useQuery(
    ["getFetchUserSchedule", shift],
    async () => {
      try {
        const endpoint = `/api/v1/users/schedule/${shift}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Users..");
      }
    }
  );
};

// ดึงข้อมูลวันหยุดทั้งหมด
export const UseFetchSchedule = (selectMonth) => {
  return useQuery(
    ["getFetchHolidays"],
    async () => {
      try {
        const endpoint = `/api/v1/schedule?month=${selectMonth}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Holidays..");
      }
    },
    {
      enabled: true, // ❌ ไม่ให้ auto run
    }
  );
};


export const UseFetchCreateSchedule = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/schedule`;
      const result = POST(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Create Schedule..");
    }
  });
};

export const UseFetchUserWorkSchedule = (userId, month, year) => {
  return useQuery(
    ["getUserWorkSchedule", userId, month, year],
    async () => {
      try {
        const endpoint = `/api/v1/schedule/user/${userId}/${month}/${year}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load User Work Schedule..");
        return [];
      }
    },
    {
      enabled: !!userId && !!month && !!year,
    }
  );
};

export const UseFetchListUser = () => {
  return useMutation(
    async (payload) => {
      try {
        const endpoint = `/api/v1/users/listUser`;
        const {result} = await POST(endpoint, payload);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Users..");
      }
    }
  )
}

export const UseFetchCreateLeaveDay = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/schedule/createLeaveDay`;
      const result = POST(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Create Leave Day..");
    }
  });
}

export const UseFetchUpdateLeaveDay = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/schedule/updateLeaveDay`;
      const result = PUT(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Create Leave Day..");
    }
  });
}

export const UseFetchDeleteLeaveDay = () => {
  return useMutation(async (id) => {
    try {
      const endPoint = `/api/v1/schedule/deleteLeaveDay/${id}`;
      const result = await DELETE(endPoint);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Delete Leave Day..");
    }
  });
}

export const UseFetchListLeaveDay = () => {
  return useQuery(
    ["getFetchListLeaveDay"],
    async () => {
      try {
        const endpoint = `/api/v1/schedule/leaveDay/list`;
        const {result}  = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Leave Day..");
      }
    },
    {
      enabled: true, // ❌ ไม่ให้ auto run
    }
  );
};

export const UseFetchApproveLeaveDay = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/schedule/approveLeaveDay`;
      const result = POST(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Approve Leave Day..");
    }
  });
}